"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.MANUAL_LOCATION_LINK = exports.LOCATION_SELECTOR = exports.LOADING_ICON = exports.SELECTOR_INPUT_CONTAINER = exports.LOCATION_SELECTOR__ROOT = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    LOCATION_SELECTOR__ROOT = (0, _cxs["default"])({
  width: "100%"
});

exports.LOCATION_SELECTOR__ROOT = LOCATION_SELECTOR__ROOT;
var SELECTOR_INPUT_CONTAINER = (0, _cxs["default"])({
  position: "relative",
  display: "flex",
  alignItems: "center",
  " > input": {
    paddingRight: "55px"
  }
});
exports.SELECTOR_INPUT_CONTAINER = SELECTOR_INPUT_CONTAINER;
var LOADING_ICON = (0, _cxs["default"])({
  position: "absolute",
  right: "15px"
});
exports.LOADING_ICON = LOADING_ICON;
var LOCATION_SELECTOR = (0, _cxs["default"])({
  position: "relative"
});
exports.LOCATION_SELECTOR = LOCATION_SELECTOR;
var MANUAL_LOCATION_LINK = (0, _cxs["default"])({
  fontSize: "10px",
  marginTop: "-7px"
});
exports.MANUAL_LOCATION_LINK = MANUAL_LOCATION_LINK;